import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { FileSpreadsheet } from "lucide-react";
import * as XLSX from "xlsx";

export default function MovementsPage() {
  const [items, setItems] = useState([]);
  const [tipo, setTipo] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const params = {};
    if (tipo) params.tipo = tipo;
    const { data } = await api.get("/movements", { params });
    setItems(data); setLoading(false);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tipo]);

  const exportExcel = () => {
    const rows = items.map(m => ({
      "Data/Ora": new Date(m.created_at).toLocaleString("it-IT"),
      "Tipo": m.tipo, "Codice": m.codice_interno, "Descrizione": m.descrizione,
      "Quantità": m.quantita, "Giac. Dopo": m.giacenza_dopo,
      "Documento": m.documento, "Causale": m.causale, "Commessa": m.commessa,
      "Cliente": m.cliente, "Macchina": m.macchina, "Matricola": m.matricola,
      "Tecnico": m.tecnico, "Utente": m.user_name, "Note": m.note,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Movimenti");
    XLSX.writeFile(wb, `germac_movimenti_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Tracciabilità</div>
          <h1 className="font-display text-4xl font-black uppercase tracking-tight">Storico Movimenti</h1>
        </div>
        <button onClick={exportExcel} className="h-11 px-4 border border-zinc-700 hover:border-[#4CAF50] uppercase text-xs tracking-widest text-zinc-300 hover:text-[#4CAF50] flex items-center gap-2" data-testid="movements-export-excel">
          <FileSpreadsheet size={16} /> Esporta Excel
        </button>
      </div>

      <div className="flex gap-2 mb-4">
        {["", "carico", "scarico", "rettifica"].map(t => (
          <button key={t} onClick={()=>setTipo(t)}
            data-testid={`movements-filter-${t || "all"}`}
            className={`px-4 h-10 border uppercase text-xs tracking-widest font-bold ${
              tipo===t ? "bg-[#4CAF50] text-white border-[#4CAF50]" : "border-zinc-700 text-zinc-400 hover:border-zinc-500"
            }`}>
            {t || "Tutti"}
          </button>
        ))}
      </div>

      <div className="gm-card overflow-x-auto">
        {loading ? (
          <div className="p-8 text-zinc-500">Caricamento...</div>
        ) : (
          <table className="gm-table">
            <thead>
              <tr>
                <th>Data/Ora</th><th>Tipo</th><th>Codice</th><th>Descrizione</th>
                <th className="text-right">Q.tà</th><th className="text-right">Dopo</th>
                <th>Riferimento</th><th>Utente</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (<tr><td colSpan="8" className="text-center text-zinc-500 py-8">Nessun movimento</td></tr>)}
              {items.map(m => (
                <tr key={m.id}>
                  <td className="font-mono-data text-xs text-zinc-400">{new Date(m.created_at).toLocaleString("it-IT")}</td>
                  <td>
                    {m.tipo === "carico" && <span className="gm-badge gm-badge-success">Carico</span>}
                    {m.tipo === "scarico" && <span className="gm-badge gm-badge-warning">Scarico</span>}
                    {m.tipo === "rettifica" && <span className="gm-badge gm-badge-muted">Rettifica</span>}
                  </td>
                  <td className="font-mono-data text-[#4CAF50]"><Link to={`/prodotti/${m.product_id}`} className="hover:underline">{m.codice_interno}</Link></td>
                  <td className="text-sm">{m.descrizione}</td>
                  <td className="text-right font-mono-data font-bold">{m.tipo === "scarico" ? "-" : m.tipo === "carico" ? "+" : "="}{m.quantita}</td>
                  <td className="text-right font-mono-data">{m.giacenza_dopo}</td>
                  <td className="text-xs text-zinc-400 max-w-[200px] truncate">{m.documento || m.causale || m.commessa || m.cliente || "—"}</td>
                  <td className="text-xs text-zinc-400">{m.user_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
